export const API_V1 = '/api/v1';

export const DEFAULT_STALE_TIME = 2 * 60 * 1000; // 2 minutes

export const DEFAULT_KYRON_CONFIG = {
  staleTime: DEFAULT_STALE_TIME,
  retry: false,
};
